import React, { useState, useEffect } from "react";
import styles from "./Invoice.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { priceFormatter, toCommas, useDebounce } from "../../utils/utils";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { initialState } from "../../initialState";
// import currencies from "../../currencies.json";
import {
  createInvoice,
  getInvoice,
  updateInvoice,
} from "../../actions/invoiceActions";
import { getClientsByUser } from "../../actions/clientActions";
import { getProductsByUser } from "../../actions/productActions";
import AddClient from "./AddClient";
import InvoiceType from "./InvoiceType";
import { useLocation } from "react-router-dom";
import Notification from "../../utils/Notification";
import { API } from "../../api";

const toNumber = (value) => Number(value) || 0;
const getLineBase = (item) => toNumber(item.quantity) * toNumber(item.unitPrice);
const getLineDiscountAmount = (item) =>
  item.discountType === "fixed"
    ? Math.min(
        getLineBase(item),
        toNumber(item.fixedDiscount) * toNumber(item.quantity)
      )
    : (getLineBase(item) * toNumber(item.discount)) / 100;
const getLineTaxAmount = (item) =>
  (getLineBase(item) * toNumber(item.tax)) / 100;
const getLineAmount = (item) =>
  getLineBase(item) - getLineDiscountAmount(item) + getLineTaxAmount(item);
const getDiscountLabel = (item) =>
  item.discountType === "fixed"
    ? `${toNumber(item.fixedDiscount).toFixed(2)} TND`
    : `${toNumber(item.discount)}%`;
const getInvoiceTotals = (items = []) =>
  items.reduce(
    (totals, item) => ({
      subTotal: totals.subTotal + getLineBase(item) - getLineDiscountAmount(item),
      vat: totals.vat + getLineTaxAmount(item),
      total: totals.total + getLineAmount(item),
    }),
    { subTotal: 0, vat: 0, total: 0 }
  );

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1),
  },
}));

const Invoice = () => {
  const location = useLocation();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [search, setSearch] = useState("");
  const searchTerm = useDebounce(search, 300);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const currency = "TND";
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(
    today.getTime() + 7 * 24 * 60 * 60 * 1000
  );
  const [client, setClient] = useState(null);

  const [type, setType] = useState("Receipt");
  const [status, setStatus] = useState("Unpaid");
  const { id } = useParams();
  const clients = useSelector((state) => state.clients.clients);
  const { products } = useSelector((state) => state.product);
  const { invoice } = useSelector((state) => state.invoices);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));

  useEffect(() => {
    getTotalCount();
    // eslint-disable-next-line
  }, [location]);

  const getTotalCount = async () => {
    try {
      await API.get(`/invoices/count?searchQuery=${user?.result?._id}`);
      //   console.log(response.data);
      //Get total count of invoice from the server and increment by one to serialized numbering of invoice
      setInvoiceData({
        ...invoiceData,
        invoiceNumber: Math.floor(Math.random() * 100000),
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getInvoice(id));
    }

    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    dispatch(
      getClientsByUser({
        userId:
          user?.result?.role === "assistant"
            ? user?.result?.userId[0]
            : user?.result?._id || user.result.googleId,
        search: searchTerm,
        page: 1,
        pageSize: 500,
      })
    );
    // eslint-disable-next-line
  }, [dispatch, , searchTerm]);

  useEffect(() => {
    dispatch(
      getProductsByUser({
        search:
          user?.result?.role === "assistant"
            ? user?.result?.userId[0]
            : user?.result?._id || user.result.googleId,
      })
    );
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
    }
  }, [invoice]);

  // useEffect(() => {
  //   if (type === "Receipt") {
  //     setStatus("Paid");
  //   } else {
  //     setStatus("Unpaid");
  //   }
  // }, [type]);

  // const defaultProps = {
  //   options: currencies,
  //   getOptionLabel: (option) => option.label,
  // };

  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  const productsProps = {
    options: products,
    getOptionLabel: (option) => option.title,
  };
  const findSelectedProduct = (productId) => {
    return products.find((product) => product._id === productId) || null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // const handleRates = (e) => {
  //   setRates(e.target.value);
  //   setInvoiceData((prevState) => ({ ...prevState, tax: e.target.value }));
  // };

  // console.log(invoiceData)
  // Change handler for dynamically added input field
  const handleChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
    setInvoiceData({ ...invoiceData, items: values });
    setVat(getInvoiceTotals(values).vat);
  };
  const handleChangeProd = (index, value) => {
    const values = [...invoiceData.items];
    if (!value) {
      values[index] = {
        ...values[index],
        itemName: "",
        unitPrice: "",
        quantity: "",
        discountType: "percentage",
        discount: 0,
        fixedDiscount: 0,
        tax: 0,
        itemId: "",
      };
      setInvoiceData({ ...invoiceData, items: values });
      setVat(getInvoiceTotals(values).vat);
      return;
    }

    values[index]["unitPrice"] = value.price;
    values[index]["itemName"] = value.title;
    values[index]["tax"] = value.vat;
    values[index]["quantity"] = "1";
    values[index]["itemId"] = value._id;
    values[index]["discountType"] = value.discountEnabled
      ? value.discountType || "percentage"
      : "percentage";
    values[index]["discount"] = value.discountEnabled ? value.discount || 0 : 0;
    values[index]["fixedDiscount"] =
      value.discountEnabled && value.discountType === "fixed"
        ? value.fixedDiscount || 0
        : 0;

    setVat(getInvoiceTotals(values).vat);

    setInvoiceData({ ...invoiceData, items: values });
  };

  useEffect(() => {
    const totals = getInvoiceTotals(invoiceData.items);
    setSubTotal(totals.subTotal);
    setVat(totals.vat);
    setTotal(totals.total);
  }, [invoiceData]);

  const handleAddField = (e) => {
    e.preventDefault();
    setInvoiceData((prevState) => ({
      ...prevState,
      items: [
        ...prevState.items,
        {
          itemName: "",
          unitPrice: "",
          quantity: "",
          discountType: "percentage",
          discount: 0,
          fixedDiscount: 0,
          amount: "",
          tax: 0,
          itemId: "",
        },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    const values = invoiceData.items.filter((_, itemIndex) => itemIndex !== index);
    setInvoiceData((prevState) => ({ ...prevState, items: values }));
    setVat(getInvoiceTotals(values).vat);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (invoice) {
      dispatch(
        updateInvoice(invoice._id, {
          ...invoiceData,
          subTotal: priceFormatter(subTotal),
          total: priceFormatter(total),
          vat: vat,
          rates: rates,
          currency: currency,
          dueDate: selectedDate,
          client,
          type: type,
          status: status,
        })
      );
      history.push(`/invoice/${invoice._id}`);
    } else {
      dispatch(
        createInvoice(
          {
            ...invoiceData,
            subTotal: priceFormatter(subTotal),
            total: priceFormatter(total),
            vat: vat,
            rates: rates,
            currency: currency,
            dueDate: selectedDate,
            invoiceNumber: `${
              invoiceData.invoiceNumber < 100
                ? Number(invoiceData.invoiceNumber).toString().padStart(3, "0")
                : Number(invoiceData.invoiceNumber)
            }`,
            client,
            type: type,
            status: status,
            paymentRecords: [],
            assistant: [user?.result?._id || user?.result?.googleId],
            creator:
              user?.result?.role === "assistant"
                ? user?.result?.userId
                : [user?.result?._id || user?.result?.googleId],
          },
          history
        )
      );
    }

    // setInvoiceData(initialState)
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }
  //notification
  const [openNotification, setOpenNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("error");
  useEffect(() => {
    // Check product quantities
    const productsWithLowQuantity = products.filter(
      (product) => product.quantity < 0
    );

    if (productsWithLowQuantity.length > 0) {
      const productNames = productsWithLowQuantity
        .map((product) => product.title)
        .join(", ");

      setMessage(`Products ${productNames} are out of stock.`);
      setOpenNotification(true);
    } else {
      setMessage("");
    }
  }, [products]);

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenNotification(false);
  };

  return (
    <div className={styles.invoiceLayout}>
      <Notification
        open={openNotification}
        handleClose={handleClose}
        message={message}
        severity={severity}
        setSeverity={setSeverity}
      />
      <form onSubmit={handleSubmit} className="mu-form">
        <AddClient setOpen={setOpen} open={open} />
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="space-between">
            <Grid item>
              {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
            </Grid>
            <Grid item>
              <InvoiceType type={type} setType={setType} />
              Invoice #:
              <div
                style={{
                  marginTop: "15px",
                  width: "100px",
                  padding: "8px",
                  display: "inline-block",
                  backgroundColor: "#f4f4f4",
                  outline: "0px solid transparent",
                }}
                contenteditable="true"
                onInput={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    invoiceNumber: e.currentTarget.textContent,
                  })
                }
              >
                <span
                  style={{ width: "40px", color: "black", padding: "15px" }}
                  contenteditable="false"
                >
                  {" "}
                  {invoiceData.invoiceNumber}
                </span>
                <br />
              </div>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Container>
          <Grid
            container
            justifyContent="space-between"
            style={{ marginTop: "40px" }}
          >
            <Grid item style={{ width: "50%" }}>
              <Container>
                <Typography
                  variant="overline"
                  style={{ color: "gray", paddingRight: "3px" }}
                  gutterBottom
                >
                  Bill to
                </Typography>

                {client && (
                  <>
                    <Typography variant="subtitle2" gutterBottom>
                      {client.name}
                    </Typography>
                    <Typography variant="body2">{client.email}</Typography>
                    <Typography variant="body2">{client.phone}</Typography>
                    <Typography variant="body2">{client.address}</Typography>
                    <Button
                      color="primary"
                      size="small"
                      style={{ textTransform: "none" }}
                      onClick={() => setClient(null)}
                    >
                      Change
                    </Button>
                  </>
                )}
                <div
                  style={client ? { display: "none" } : { display: "block" }}
                >
                  <Autocomplete
                    {...clientsProps}
                    PaperComponent={CustomPaper}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={!invoice && true}
                        label="Select Customer"
                        margin="normal"
                        variant="outlined"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    )}
                    value={clients?.name}
                    onChange={(event, value) => setClient(value)}
                  />
                </div>
                {!client && (
                  <>
                    <Grid item style={{ paddingBottom: "10px" }}>
                      <Chip
                        avatar={<Avatar>+</Avatar>}
                        label="New Customer"
                        onClick={() => setOpen(true)}
                        variant="outlined"
                      />
                    </Grid>
                  </>
                )}
              </Container>
            </Grid>

            <Grid item style={{ marginRight: 20, textAlign: "right" }}>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Status
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                style={{ color: status === "Paid" ? "Unpaid" : "red" }}
              >
                {status}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Date
              </Typography>
              <Typography variant="body2" gutterBottom>
                {moment().format("MMM Do YYYY")}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Due Date
              </Typography>
              <Typography variant="body2" gutterBottom>
                {selectedDate
                  ? moment(selectedDate).format("MMM Do YYYY")
                  : "27th Sep 2021"}
              </Typography>
              <Typography variant="overline" gutterBottom>
                Amount
              </Typography>
              <Typography variant="h6" gutterBottom>
                {currency} {toCommas(total)}
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Discount</TableCell>
                  <TableCell>Tax(%)</TableCell>
                  <TableCell>Amount</TableCell>

                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData.items.map((itemField, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row" style={{ width: "40%" }}>
                      {" "}
                      <Autocomplete
                        {...productsProps}
                        PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required={!invoice && true}
                            label="Select Product"
                            margin="normal"
                            variant="outlined"
                            name="itemName"
                          />
                        )}
                        value={findSelectedProduct(itemField.itemId)}
                        onChange={(event, value) =>
                          handleChangeProd(index, value)
                        }
                      />
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="quantity"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.quantity}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="unitPrice"
                        // onChange={(e) => handleChange(index, e)}
                        value={itemField.unitPrice}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="text"
                        name="discount"
                        value={getDiscountLabel(itemField)}
                        placeholder="0"
                        disabled
                      />
                    </TableCell>
                    <TableCell align="right">
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="tax"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.tax}
                        disabled
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="amount"
                        value={getLineAmount(itemField).toFixed(2)}
                        disabled
                      />{" "}
                    </TableCell>

                    <TableCell align="right">
                      <IconButton onClick={() => handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button onClick={handleAddField}>+</button>
          </div>
        </div>

        <div className={styles.invoiceSummary}>
          <div className={styles.summary}>Invoice Summary</div>
          <div className={styles.summaryItem}>
            <p>Sub total:</p>
            <h4>{priceFormatter(subTotal)}</h4>
          </div>
          <div className={styles.summaryItem}>
            <p>VAT(TND):</p>
            <h4>{vat}</h4>
          </div>
          <div className={styles.summaryItem}>
            <p>Total</p>
            <h4 style={{ color: "black", fontSize: "18px", lineHeight: "8px" }}>
              {currency} {toCommas(total)}
            </h4>
          </div>
        </div>

        <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginRight: 10 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={styles.note}>
          <h4>Note/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) =>
              setInvoiceData({ ...invoiceData, notes: e.target.value })
            }
            value={invoiceData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            style={{ justifyContentContent: "center" }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
        </Grid>
      </form>
    </div>
  );
};

export default Invoice;
